import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

export const fetchAmenities = createAsyncThunk(
  "/amenities/fetchAmenities",
  async (info, { rejectWithValue }) => {
    try {
      const response = await api.post("/amenities", info);
      return response.data; // ✅ Ensure data is returned
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch amenities"
      );
    }
  }
);

const amenitiesSlice = createSlice({
  name: "amenities",
  initialState: {
    amenities: [],
    totalAmenities: 0,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAmenities.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAmenities.fulfilled, (state, { payload }) => {
        // console.log(payload);
        state.amenities = payload.amenities;
        state.totalAmenities = payload.totalAmenities;
      })
      .addCase(fetchAmenities.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default amenitiesSlice.reducer;
